import { FC, ReactNode } from 'react'
import * as styles from 'components/features/pfm/PeerDefinition/PeerDefinition.styl'


export type PeerDefinitionProps = {
  isRange: boolean

  // definition
  age: ReactNode
  income: ReactNode
  location: ReactNode
  area_type: ReactNode
  creditscore: ReactNode
  housing_type: ReactNode
}

export const PeerDefinition: FC<PeerDefinitionProps> = (props) => {
  const {
    isRange,
    age,
    income,
    location,
    area_type,
    creditscore,
    housing_type,
  } = props

  const rangeCopy = isRange ? 'Range' : ''

  return (
    <dl className={ styles.definitions }>
      <dt className={ styles.definitionTitle }>Age { rangeCopy }</dt>
      <dd className={ styles.definitionBody }>{ age }</dd>
      <dt className={ styles.definitionTitle }>Income { rangeCopy }</dt>
      <dd className={ styles.definitionBody }>{ income }</dd>
      <dt className={ styles.definitionTitle }>Location</dt>
      <dd className={ styles.definitionBody }>{ location }</dd>
      <dt className={ styles.definitionTitle }>Location Type</dt>
      <dd className={ styles.definitionBody }>{ area_type }</dd>
      <dt className={ styles.definitionTitle }>Credit Score { rangeCopy }</dt>
      <dd className={ styles.definitionBody }>{ creditscore }</dd>
      <dt className={ styles.definitionTitle }>Housing Type</dt>
      <dd className={ styles.definitionBody }>{ housing_type }</dd>
    </dl>
  )
}

PeerDefinition.defaultProps = {
  isRange: false,
}
